<template>
  <div id="wrapper">
      <!--add a bank if not added-->
      <div class="compliance-notification" v-if="Number(compliance) !== 8">
        <div class="compliance-notification__icon">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="32" height="32" viewBox="0 0 32 32">
            <defs><path id="aredi" d="M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m0-13a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V6a1 1 0 0 0-1-1m0 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2"></path></defs> <g fill="none" fill-rule="evenodd"><circle cx="16" cy="16" r="16" fill="#182a9c" opacity=".409"></circle> <g transform="translate(6 6)"><circle cx="10" cy="10" r="9" fill="#FFF"></circle> <use fill="#182a9c" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#aredi"></use></g></g>
          </svg>
        </div>
        <div class="compliance-notification__button">
          <!-- <a class="btn btn--primary btn--compact" data-toggle="modal" data-target="#complianceModal">Fill out additional Details</a> -->
          <a @click="redirect" class="btn btn--primary btn--compact">Fill out additional Details</a>
        </div>
        <div class="compliance-notification__text">
          <!-- <a class="default-style" data-toggle="modal" data-target="#complianceModal">Fill out additional Details</a> to start sending payments with Moneywave. -->
          <a @click="redirect" class="default-style">Fill out additional Details</a> to start sending payments with Moneywave.
        </div>
      </div>
      <nav class="nav nav--main" :class="{ 'nav--noticePresent': (Number(compliance) !== 8) }">
        <!-- Navigation block right -->
        <div class="nav__right">
          <!-- navigation block item -->
          <div class="nav__item nav__item--top nav__item--search">
            <!-- navigation block item link -->
            <span class="nav__item__link nav__item__link--top nav__item__link--noHover">
                <span class="search hidden--xs">
                    <span class="search__icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                            <path fill="#919EAB" fill-rule="evenodd" d="M8 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8m9.707 4.293l-4.82-4.82A5.968 5.968 0 0 0 14 8 6 6 0 0 0 2 8a6 6 0 0 0 6 6 5.968 5.968 0 0 0 3.473-1.113l4.82 4.82a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414"/>
                        </svg>
                    </span>
                    <span class="search__input">
                      <form action="" @submit.prevent="getFilteredData(filteredSearch)">
                        <input type="text" ref="field" class="form__input" placeholder="Search references, account numbers, beneficiaries and balance." v-model="filteredSearch" v-click-outside="removeFilter">
                      </form>
                    </span>
                </span>

            <template  v-if="!filteredSearchEmpty">
              <div class="row" style="width:100%" v-for="(searchList, index) in newFilteredData" :key="index">
                <div class="row__group" style="display: flex;  box-shadow: 0 1.2px 5.68px 0 rgba(0, 0, 0, 0.12); justify-content: space-between; width: 100%; padding: 15px; background: #fff; z-index: 2 ">
                    <div class="row__header" style="width: 15%; background-color: white; padding:10px;border-right: 1px solid lightgrey">
                      <p @click="switchToBenefi(searchList.id)" v-if="keyForFilteredData[index] === 'transaction'" class="row__header__text" style="color:black; text-transform: capitalize"> {{keyForFilteredData[index]}} </p>
                      <p class="row__header__text" v-else-if="keyForFilteredData[index] !== 'transaction'" style="color:black; text-transform: capitalize"> {{keyForFilteredData[index]}} </p>
                    </div>
                    <div class="row__data" style="width: 85%; background-color: white; display:flex; align-items: center; justify-content: space-evenly" v-if="keyForFilteredData[index] === 'beneficiary'">
                      <div style="width: 35%; padding: 0 20px;"> {{searchList.alias}} <br> <small> Alias</small></div>
                      <p style="width: 50%;"> {{searchList.accountName.toLowerCase()}}<br> <small> Account Name</small></p>
                      <p style="width: 15%;"> {{searchList.accountNumber}}<br> <small> Account No.</small></p>
                    </div>
                    <div @click="switchToBenefi(searchList.id)" class="row__data" style="width: 85%; background-color: white; display:flex; align-items: center;" v-if="keyForFilteredData[index] === 'transaction'">
                      <!--<router-link :to="{name:'single-transfer', params: {id: searchList.id}}" class="">-->
                        <div style="width: 15%; padding: 0 20px;"> {{searchList.currency}} <br/> {{searchList.amount | numeralize('0,0')}}</div>
                        <p style="width: 30%;" v-if="searchList.accountName && searchList.accountNumber"> {{searchList.accountNumber}} <br> <small>{{searchList.accountName.toLowerCase()}}</small> </p>
                        <p style="width: 30%;" v-else> No account Number <br> <small>No account Name</small> </p>
                        <p style="width: 40%;"> <small> {{searchList.ref}} </small> <br> <small> {{ momentDate(searchList.createdAt) }} </small></p>
                        <p style="width: 10%;"><span v-if="searchList.reversed" class="tag" :class="['tag--reversed']">Reversed</span>
                        <span v-else class="tag" :class="['tag--' + searchList.status]">{{searchList.status}}</span></p>
                      <!--</router-link>-->
                      <!--<p class="row__data__text"> <router-link :to="{name:'single-transfer', params: {id: searchList.id}}" class="btn btn&#45;&#45;default btn&#45;&#45;compact">View</router-link></p>-->
                      <!--<div class="table__data" :class="{'inverted': showPanel().isActive(transfer)}">-->
                        <!--<router-link :to="{name:'single-transfer', params: {id: searchList.id}}" class="btn btn&#45;&#45;default btn&#45;&#45;compact">View</router-link>-->
                      <!--</div>-->
                    </div>
                    <div class="row__data" style="width: 85%; background-color: white; display:flex; align-items: center; justify-content: space-evenly" v-if="keyForFilteredData[index] === 'wallet'">
                      <p class="row__data__text"> {{searchList.name}}</p>
                      <p class="row__data__text"> {{searchList.currency.shortCode}} {{searchList.balance}}</p>
                      <!--<p class="row__data__text"> {{searchList.currency.shortCode}}</p>-->
                    </div>
                </div>
              </div>
            </template>


              <!--
              <div class="table__row" v-if="!filteredSearchEmpty">
                <div class="table__section table__section--body" v-for="(searchList, index) in filteredData">
                  <div style="display: inherit;">
                    <div>
fjyhfjhfkfuddk
                    </div>
                    <div class="table__row" v-if="index === 'beneficiary'">
                    <div class="table__data">
                      {{index}}
                    </div>
                    <div class="table__data">
                      <div class="table__data--bold">
                        {{searchList.alias}}
                      </div>
                    </div>

                  </div>
                  </div>

                </div>
              </div> -->
            </span>
          </div>

          <!--notification-->

          <div class="nav__item nav__item--top">
            <!-- <div class="nav__item__link nav__item__link--top nav__item__link--noHover">
              <div class="tag__notifications tag__notifications--circle">9</div>
            </div> -->
          </div>

          <!--profile, settings, etc. trigger-->
          <div v-click-outside="dropDownControl">
            <div class="nav__item nav__item--top">
              <div class="nav__item__link nav__item__link--top nav__item__link--noHover" @click="dropdownOpen = !dropdownOpen">
                <div class="account__container">
                  <div class="account__user-avatar">
                    <svg width="28px" height="28px" viewBox="0 0 28 28" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <defs>
                        <circle id="path-1" cx="14" cy="14" r="14"></circle>
                      </defs>
                      <g id="Overview" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-1268.000000, -102.000000)">
                        <g id="Group-52" transform="translate(342.000000, 96.000000)">
                          <g id="User-profile-and-not" transform="translate(920.000000, 0.000000)">
                            <g id="Avatar-new">
                              <g id="Group-48" transform="translate(6.000000, 6.000000)">
                                <mask id="mask-2" fill="white">
                                  <use xlink:href="#path-1"></use>
                                </mask>
                                <use id="Oval-5" fill="#FFFFFF" xlink:href="#path-1"></use>
                                <path d="M14,-0.823529412 C5.83058824,-0.823529412 -0.823529412,5.83058824 -0.823529412,14 C-0.823529412,22.1694118 5.83058824,28.8235294 14,28.8235294 C22.1694118,28.8235294 28.8235294,22.1694118 28.8235294,14 C28.8235294,5.83058824 22.1694118,-0.823529412 14,-0.823529412 Z M6.55529412,24.4423529 L10.64,22.0047059 C11.4635294,21.5105882 11.9576471,20.6211765 11.9576471,19.6988235 L11.9576471,17.7223529 C11.9576471,17.7223529 11.9576471,17.7223529 11.9576471,17.7223529 C11.9576471,17.6894118 11.9576471,17.6564706 11.9576471,17.6235294 C11.9576471,17.6235294 11.9576471,17.5905882 11.9576471,17.5905882 C11.9576471,17.5576471 11.9576471,17.5247059 11.9247059,17.5247059 C11.9247059,17.5247059 11.9247059,17.4917647 11.9247059,17.4917647 C11.9247059,17.4917647 11.8917647,17.4588235 11.8917647,17.4588235 C11.8917647,17.4258824 11.8588235,17.4258824 11.8588235,17.3929412 C11.8588235,17.3929412 11.8258824,17.36 11.8258824,17.36 C11.7929412,17.3270588 11.7929412,17.3270588 11.76,17.2941176 C11.76,17.2941176 11.76,17.2941176 11.76,17.2941176 C11.1670588,16.7011765 10.64,15.3835294 10.4752941,14.9552941 C10.4094118,14.7576471 10.2776471,14.6258824 10.1129412,14.56 C9.84941176,14.4611765 9.68470588,14.0658824 9.61882353,13.8682353 L9.61882353,12.0564706 C9.61882353,11.9905882 9.71764706,11.8588235 9.81647059,11.76 C9.94823529,11.6282353 10.0141176,11.4635294 10.0141176,11.2988235 C10.0141176,11.2658824 10.0141176,8.99294118 10.7717647,7.31294118 C11.2988235,6.12705882 13.2094118,5.92941176 13.9341176,5.96235294 L14.0988235,5.96235294 C14.1317647,5.96235294 16.6023529,5.92941176 17.2282353,7.31294118 C17.9858824,9.02588235 17.9858824,11.2988235 17.9858824,11.2988235 C17.9858824,11.4635294 18.0517647,11.6282353 18.1835294,11.76 C18.2494118,11.8258824 18.3482353,11.9905882 18.3811765,12.0235294 L18.3811765,13.8682353 C18.3152941,14.0329412 18.1505882,14.4282353 17.8870588,14.56 C17.7223529,14.6258824 17.5576471,14.7905882 17.5247059,14.9552941 C17.36,15.4164706 16.8658824,16.7341176 16.24,17.2941176 C16.24,17.2941176 16.24,17.2941176 16.24,17.2941176 C16.2070588,17.3270588 16.2070588,17.3270588 16.1741176,17.36 C16.1741176,17.36 16.1411765,17.3929412 16.1411765,17.3929412 C16.1411765,17.4258824 16.1082353,17.4258824 16.1082353,17.4588235 C16.1082353,17.4588235 16.0752941,17.4917647 16.0752941,17.4917647 C16.0752941,17.4917647 16.0752941,17.5247059 16.0752941,17.5247059 C16.0752941,17.5576471 16.0423529,17.5905882 16.0423529,17.5905882 C16.0423529,17.5905882 16.0423529,17.6235294 16.0423529,17.6235294 C16.0423529,17.6564706 16.0423529,17.6894118 16.0423529,17.7223529 C16.0423529,17.7223529 16.0423529,17.7223529 16.0423529,17.7223529 L16.0423529,19.6988235 C16.0423529,20.6541176 16.5694118,21.5435294 17.36,22.0047059 L21.4447059,24.4423529 C19.3364706,25.9576471 16.7670588,26.8470588 14,26.8470588 C11.2329412,26.8470588 8.66352941,25.9576471 6.55529412,24.4423529 Z M22.5647059,23.5858824 C22.5427451,23.5858824 21.0384314,22.6964706 18.0517647,20.9176471 C17.6235294,20.6541176 17.36,20.2258824 17.36,19.7317647 L17.36,18.0188235 C18.0188235,17.2611765 18.48,16.1082353 18.6776471,15.6141176 C19.4352941,15.12 19.6658824,14.1976471 19.6988235,14.0988235 C19.6988235,14.0658824 19.6988235,14 19.6988235,13.9670588 L19.6988235,12.0235294 C19.6988235,11.6282353 19.4682353,11.2658824 19.3035294,11.0352941 C19.2705882,10.3435294 19.1388235,8.36705882 18.4141176,6.75294118 C17.4258824,4.51294118 14.1647059,4.61176471 14.0658824,4.61176471 L13.9341176,4.61176471 C13.8023529,4.61176471 10.5411765,4.51294118 9.55294118,6.75294118 C8.82823529,8.36705882 8.69647059,10.3435294 8.66352941,11.0352941 C8.49882353,11.2658824 8.26823529,11.6282353 8.26823529,12.0235294 L8.26823529,13.9670588 C8.26823529,14 8.26823529,14.0658824 8.26823529,14.0988235 C8.30117647,14.2305882 8.53176471,15.1529412 9.28941176,15.6141176 C9.48705882,16.1411765 9.94823529,17.2611765 10.6070588,18.0188235 L10.6070588,19.7317647 C10.6070588,20.2258824 10.3435294,20.6870588 9.91529412,20.9176471 L5.46823529,23.5529412 C2.8,21.2141176 1.15294118,17.7882353 1.15294118,14 C1.15294118,6.91764706 6.91764706,1.15294118 14,1.15294118 C21.0823529,1.15294118 26.8470588,6.91764706 26.8470588,14 C26.8470588,17.7882353 25.2,21.2141176 22.5647059,23.5858824 Z M14,-0.823529412 C5.83058824,-0.823529412 -0.823529412,5.83058824 -0.823529412,14 C-0.823529412,22.1694118 5.83058824,28.8235294 14,28.8235294 C22.1694118,28.8235294 28.8235294,22.1694118 28.8235294,14 C28.8235294,5.83058824 22.1694118,-0.823529412 14,-0.823529412 Z" id="Shape" fill="#E5E7FC" fill-rule="nonzero" mask="url(#mask-2)"></path>
                                <path d="M10.64,23.0047059 C11.4635294,22.5105882 11.9576471,21.6211765 11.9576471,20.6988235 L11.9576471,18.7223529 C11.9576471,18.6894118 11.9576471,18.6564706 11.9576471,18.6235294 C11.9576471,18.5576471 11.9576471,18.5247059 11.9247059,18.5247059 C11.9247059,18.4917647 11.8917647,18.4588235 11.8917647,18.4588235 C11.8917647,18.4258824 11.8588235,18.4258824 11.8588235,18.3929412 C11.7929412,18.3270588 11.7929412,18.3270588 11.76,18.2941176 C11.1670588,17.7011765 10.64,16.3835294 10.4752941,15.9552941 C10.4094118,15.7576471 10.2776471,15.6258824 10.1129412,15.56 C9.84941176,15.4611765 9.68470588,15.0658824 9.61882353,14.8682353 L9.61882353,13.0564706 C9.61882353,12.9905882 9.71764706,12.8588235 9.81647059,12.76 C9.94823529,12.6282353 10.0141176,12.4635294 10.0141176,12.2988235 C10.0141176,12.2658824 10.0141176,9.99294118 10.7717647,8.31294118 C11.2988235,7.12705882 13.2094118,6.92941176 13.9341176,6.96235294 L14.0988235,6.96235294 C14.1317647,6.96235294 16.6023529,6.92941176 17.2282353,8.31294118 C17.9858824,10.0258824 17.9858824,12.2988235 17.9858824,12.2988235 C17.9858824,12.4635294 18.0517647,12.6282353 18.1835294,12.76 C18.2494118,12.8258824 18.3482353,12.9905882 18.3811765,13.0235294 L18.3811765,14.8682353 C18.3152941,15.0329412 18.1505882,15.4282353 17.8870588,15.56 C17.7223529,15.6258824 17.5576471,15.7905882 17.5247059,15.9552941 C17.36,16.4164706 16.8658824,17.7341176 16.24,18.2941176 C16.2070588,18.3270588 16.2070588,18.3270588 16.1741176,18.36 C16.1411765,18.4258824 16.1082353,18.4258824 16.1082353,18.4588235 C16.0752941,18.4917647 16.0752941,18.5247059 16.0752941,18.5247059 C16.0752941,18.5576471 16.0423529,18.5905882 16.0423529,18.5905882 C16.0423529,18.6564706 16.0423529,18.6894118 16.0423529,18.7223529 C16.0423529,18.7223529 16.0423529,19.3811765 16.0423529,20.6988235 C16.0423529,21.6541176 16.5694118,22.5435294 17.36,23.0047059 L23.4447059,26.4423529 C21.3364706,27.9576471 16.7670588,28.8470588 14,28.8470588 C11.2329412,28.8470588 6.66352941,27.9576471 4.55529412,26.4423529 L10.64,23.0047059 Z M35.5647059,31.5858824 C35.5427451,31.5858824 29.705098,28.3631373 18.0517647,21.9176471 C17.6235294,21.6541176 17.36,21.2258824 17.36,20.7317647 L17.36,19.0188235 C18.0188235,18.2611765 18.48,17.1082353 18.6776471,16.6141176 C19.4352941,16.12 19.6658824,15.1976471 19.6988235,15.0988235 C19.6988235,15.0658824 19.6988235,15 19.6988235,14.9670588 L19.6988235,13.0235294 C19.6988235,12.6282353 19.4682353,12.2658824 19.3035294,12.0352941 C19.2705882,11.3435294 19.1388235,9.36705882 18.4141176,7.75294118 C17.4258824,5.51294118 14.1647059,5.61176471 14.0658824,5.61176471 L13.9341176,5.61176471 C13.8023529,5.61176471 10.5411765,5.51294118 9.55294118,7.75294118 C8.82823529,9.36705882 8.69647059,11.3435294 8.66352941,12.0352941 C8.49882353,12.2658824 8.26823529,12.6282353 8.26823529,13.0235294 L8.26823529,14.9670588 C8.26823529,15 8.26823529,15.0658824 8.26823529,15.0988235 C8.30117647,15.2305882 8.53176471,16.1529412 9.28941176,16.6141176 C9.48705882,17.1411765 9.94823529,18.2611765 10.6070588,19.0188235 L10.6070588,20.7317647 C10.6070588,21.2258824 10.3435294,21.6870588 9.91529412,21.9176471 L-3.53176471,29.5529412" id="Shape-Copy" fill="#7983ED" fill-rule="nonzero" mask="url(#mask-2)"></path>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>
                </div>
              </div>

              <!-- Dropdown -->
              <div class="dropdown" :class="{'active': dropdownOpen}">
                <div class="dropdown__item">
                  <router-link :to="{name:'profile-settings'}" class="dropdown__item__link dropdown__item__link--user">{{userFullName}}</router-link>
                </div>
                <div class="dropdown__item">
                  <router-link :to="{name:'config-settings'}" class="dropdown__item__link dropdown__item__link--user">Settings</router-link>
                </div>
                <div class="dropdown__item">
                  <router-link :to="{name:'compliance'}" class="dropdown__item__link dropdown__item__link--user">Compliance Info</router-link>
                </div>
                <div class="dropdown__item">
                  <a href="https://moneywave.gitbook.io/doc/" target="_blank" class="dropdown__item__link dropdown__item__link--user">Documentation</a>
                </div>
                <div class="dropdown__item">
                  <div class="dropdown__item__link dropdown__item__link--user" @click="handleLogout()">Sign out</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <!-- Hamburger Menu -->
      <div class="navigation-menu" @click="open = !open">
        <svg width="20px" height="20px" viewBox="0 0 69 51" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g stroke="none" stroke-width="1" fill-rule="evenodd">
            <g fill-rule="nonzero" stroke="none">
              <g>
                <rect :class="open? 'left-x' : ''" x="0" y="0" width="69" height="6.2072333" rx="3.10361665"></rect>
                <rect :class="open? 'no-x' : ''" x="0" y="22" width="69" height="6.2072333" rx="3.10361665"></rect>
                <rect :class="open? 'right-x' : ''" x="0" y="44.7927667" width="69" height="6.2072333" rx="3.10361665"></rect>
              </g>
            </g>
          </g>
        </svg>
      </div>

      <!-- SIDEBAR -->
      <sidebar-view :open="open"></sidebar-view>
      <!-- Notifications -->
      <div class="notifications">
        <!-- Notifications header -->
        <div class="notifications__header">
          <!-- Notification header title -->
          <div class="notifications__header__title">Notifications</div>
          <!-- Notification header icons -->
          <div class="notifications__header__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
              <path fill="#637381" fill-rule="evenodd" d="M17.707 9.293l-5-5a.999.999 0 1 0-1.414 1.414L14.586 9H3a1 1 0 1 0 0 2h11.586l-3.293 3.293a.999.999 0 1 0 1.414 1.414l5-5a.999.999 0 0 0 0-1.414"/>
            </svg>
          </div>
        </div>
        <!-- Notifications__content-->
        <div class="notifications__content">
          <!-- Notification item -->
          <div class="notifications__content__item">
            <!-- notification content item title -->
            <div class="notifications__content__item__title">Update Alert!</div>
            <div class="notifications__content__item__text">Yo you can now create some rules that blacklists customers based on set patterns.</div>
          </div>
        </div>
        <!-- Notification see more -->
        <div class="notifications__more">See More</div>
      </div>

      <!--main views-->
      <main class="main" :class="{ 'main--notice-present': (Number(compliance) !== 8) }">
        <div class="main__container">
          <router-view/>
        </div>
      </main>

      <!-- compliance modal -->
      <div class="modal fade" id="complianceModal" tabindex="-1" role="dialog" aria-labelledby="complianceModal">
        <!-- Modal Dialog -->
        <div class="modal__dialog modal__dialog--xlg" role="document">
          <!-- Modal content -->
          <div class="modal__content">
            <div class="modal__header">
              <div class="modal__title">
                <div class="compliance__step__title">Add your <span>company details</span></div>
                <div class="">
                  <span class="tag tag--light-green">{{step}} of {{total}}</span>
                  <span class="compliance__step__info">company details</span>
                </div>
              </div>
              <!-- Modal close button -->
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                  <path fill="#C0C6D8" fill-rule="nonzero" d="M8.254 6.5l4.383-4.382A1.24 1.24 0 0 0 10.882.363L6.5 4.746 2.118.363A1.24 1.24 0 1 0 .363 2.118L4.746 6.5.363 10.882a1.24 1.24 0 0 0 1.755 1.755L6.5 8.254l4.382 4.383a1.24 1.24 0 1 0 1.755-1.755L8.254 6.5z" />
                </svg>
              </button>
            </div>
            <!-- Modal Body -->
            <div class="modal__body modal__body--pad--mini" v-if="notDone">
              <v-form ref="file" :schema="formSchema" :count="3" :total="Object.keys(this.new_json_data).length" :new_schema="new_json_data" :step="this.step" :notDone="true" :next="changeStep" :data="objArrData" :submitFile="handleNewFileUpload" :submit="newSubmitVerification"></v-form>
              <!--<auto_implemented_form :schema="formSchema" :submit="countData()"></auto_implemented_form>-->
              <!--<transition name="slide-fade">-->
                <!--<div class="compliance__steps compliance__steps&#45;&#45;one">-->

                  <!--<form action="" class="form disburse-form disburse-form__single">-->
                    <!--<v-form :schema="formSchema" :count="3" :total="6"></v-form>-->
                    <!--<div class="form__item">-->
                      <!--<a class="btn btn&#45;&#45;primary btn&#45;&#45;block" @click="countData()">NEXT STEP</a>-->
                    <!--</div>-->
                  <!--</form>-->
                <!--</div>-->
              <!--</transition>-->

              <!--<transition name="slide-fade">-->
                <!--<div class="compliance__steps compliance__steps&#45;&#45;one" v-if="isStepOne && notDone">-->

                  <!--<form action="" class="form disburse-form disburse-form__single">-->

                    <!--&lt;!&ndash;bank info, if bank account is selected&ndash;&gt;-->
                    <!--<transition name="slide-fade" >-->
                      <!--<div class="compliance__steps__bank">-->
                        <!--<v-form :schema="formSchema"></v-form>-->
                        <!--<div class="form__item">-->
                          <!--<label class="form__label&#45;&#45;span form&#45;&#45;left">Company's<span> Type</span></label>-->
                          <!--<div class="amount-input form&#45;&#45;right">-->
                            <!--<input type="text" class="form__input" id="type1"  placeholder="Business" v-model="companyType">-->
                          <!--</div>-->
                        <!--</div>-->

                        <!--<div class="form__item">-->
                          <!--<label for="accountName" class="form__label&#45;&#45;span form&#45;&#45;left">Contact<span> Name</span></label>-->
                          <!--<div class="amount-input form&#45;&#45;right">-->
                            <!--<input type="text" class="form__input" id="accountName"  placeholder="Google" v-model="contactName">-->
                          <!--</div>-->
                        <!--</div>-->

                        <!--<div class="form__item form__item&#45;&#45;not-last">-->
                          <!--<label for="contatcsPhone" class="form__label&#45;&#45;span form&#45;&#45;left">Contact<span> Phone</span></label>-->
                          <!--<div class="amount-input form&#45;&#45;right">-->
                            <!--<input type="text" class="form__input" id="contatcsPhone"  placeholder="+234 703 134 2903" v-model="contactPhone">-->
                          <!--</div>-->
                        <!--</div>-->

                        <!--<div class="form__item form__item&#45;&#45;not-last">-->
                          <!--<label for="Country" class="form__label&#45;&#45;span form&#45;&#45;left"><span> Country</span></label>-->
                          <!--<div class="amount-input form&#45;&#45;right">-->
                            <!--<input type="text" class="form__input" id="Country"  placeholder="Nigeria" v-model="country">-->
                          <!--</div>-->
                        <!--</div>-->
                        <!--&lt;!&ndash;<div class="small-text">Resolving account name</div>&ndash;&gt;-->

                      <!--</div>-->
                    <!--</transition>-->

                    <!--<div class="form__item">-->
                      <!--<a class="btn btn&#45;&#45;primary btn&#45;&#45;block" @click="stepOneComplete()">NEXT STEP</a>-->
                    <!--</div>-->
                  <!--</form>-->
                <!--</div>-->
              <!--</transition>-->

              <!--step two, upload driver's license, if individual-->
              <!--<transition name="slide-fade">-->
                <!--<div class="compliance__steps__bank compliance__steps&#45;&#45;two" v-if="isStepOneComplete && isStepTwo && notDone">-->
                  <!--<form action="" class="form disburse-form disburse-form__single">-->
                    <!--<div class="">-->
                      <!--<div class="">-->
                        <!--<div class="">-->
                          <!--<div class="">Please upload your <span style="font-weight: bold;">OPERATING LICENSE DOCUMENT ID</span></div>-->
                        <!--</div>-->
                        <!--<div class="panel__content" style="padding-left: 0; margin-left: 0;">-->
                          <!--<label style="width: 100%; text-align: center;">-->
                            <!--<input type="file" id="file5" ref="file" v-on:change="handleFileUpload()"/>-->
                          <!--</label>-->
                        <!--</div>-->
                        <!--<div class="form__item form__item&#45;&#45;not-last">-->
                          <!--<label for="registered_name" class="form__label&#45;&#45;span form&#45;&#45;left">Registered<span> Name</span></label>-->
                          <!--<div class="amount-input form&#45;&#45;right">-->
                            <!--<input type="text" class="form__input" id="registered_name"  placeholder="Google" v-model="registeredName">-->
                          <!--</div>-->
                        <!--</div>-->
                        <!--<div class="form__item form__item&#45;&#45;not-last">-->
                          <!--<label for="registration_number" class="form__label&#45;&#45;span form&#45;&#45;left">Registration<span> Number</span></label>-->
                          <!--<div class="amount-input form&#45;&#45;right">-->
                            <!--<input type="text" class="form__input" id="registration_number"  placeholder="+123 0988929" v-model="registeredNumber">-->
                          <!--</div>-->
                        <!--</div>-->
                        <!--<div class="form__item form__item&#45;&#45;not-last">-->
                          <!--<label for="product_url" class="form__label&#45;&#45;span form&#45;&#45;left">Product<span> Url</span></label>-->
                          <!--<div class="amount-input form&#45;&#45;right">-->
                            <!--<input type="text" class="form__input" id="product_url"  placeholder="https://www.google.com" v-model="url">-->
                          <!--</div>-->
                        <!--</div>-->
                      <!--</div>-->
                      <!--<div class="form__item">-->
                        <!--<button class="btn btn&#45;&#45;primary btn&#45;&#45;block submit_button" id="submit_button" @click="submitVerification()">Submit</button>-->
                      <!--</div>-->
                    <!--</div>-->
                  <!--</form>-->
                <!--</div>-->
              <!--</transition>-->


            </div>
            <div class="disburse__result text-center" style="background-color: #F4F6F8; padding-bottom: 90px;" v-if="done">
              <div v-if="success">
                <!--success icon-->
                <div class="result-img">
                  <svg
                          class="icon icon--custom-big"
                          enable-background="new 0 0 50 50"
                          version="1.1"
                          viewBox="0 0 50 50"
                          xml:space="preserve"
                          xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="25" cy="25" r="25" fill="#25AE88"></circle>
                    <polyline
                            points="38 15 22 33 12 25"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                            stroke-width="2"
                    ></polyline>
                  </svg>
                </div>
                <p class="disburse__result__success success-text">Additional Documents Added successfully!</p>
                <button
                        class="btn btn--primary" data-dismis="modal"
                        aria-label="Close"
                        data-toggle="modal"
                        data-target="#complianceModal"
                        @click="endModal()"
                >End</button>
              </div>

              <div v-if="failed">
                <div class="result-img" style="">
                  <svg
                          enable-background="new 0 0 50 50"
                          version="1.1"
                          viewBox="0 0 50 50"
                          xml:space="preserve"
                          xmlns="http://www.w3.org/2000/svg"
                          class="icon icon--custom-big"
                  >
                    <circle cx="25" cy="25" r="25" fill="#D75A4A"></circle>
                    <polyline
                            points="16 34 25 25 34 16"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            stroke-width="2"
                    ></polyline>
                    <polyline
                            points="16 16 25 25 34 34"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            stroke-width="2"
                    ></polyline>
                  </svg>
                </div>
                <p
                        v-for="(error,index) in complianceError" :key="index"
                        class="disburse__result__error error-text"
                >{{error}}</p>
                <button
                        class="btn btn--primary"
                        @click="endModal()"
                >Retry</button>
                <button
                        class="btn btn--default"
                        @click="endModal()" data-dismis="modal"
                        aria-label="Close"
                        data-toggle="modal"
                        data-target="#complianceModal"
                >End</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<style lang="scss">
  @import './../../assets/stylesheets/scss/main';

  //styles for the transition classes
  /*****************************************/
  .slide-fade-enter-active {
    transition: all 1.2s ease;
  }

  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(12px);
    opacity: 0;
  }
  /*****************************************/
</style>

<script>
  import SidebarView from '@/components/partials/SidebarView'
  import {logout} from '../../utils/auth/authService'
  import {globalSearch} from '../../utils/overview/overviewService'
  import {verifiedService} from '../../utils/verified/verifiedServices'
  import Vue from 'vue';
  import {getUser} from '../../utils/user/getUserDetails'
  import moment from 'moment';
  import { uploadFile } from "../../utils/upload/fileUpload"




  // total, max per slide, current grouping, total grouping

  const textInput = {
    props: {
      field: { required: true },
      data: { required: true }
    },



    template: `
            <div class="form__item">
              <label class="form__label--span form--left "><span>{{ field.title }}</span></label>
              <div class="amount-input form--right" v-if="field.required === true">
                <input class="form__input" type="text" :placeholder="field.title" v-model="data[field.name]">
              </div>
              <div class="amount-input form--right" v-else-if="field.required === false">
                <input class="form__input" type="text" :placeholder="field.title" v-model="data[field.name]">
              </div>
            </div>
            `
  };

  // Checkbox input field component
  const checkboxInput = {
    props: {
      field: { required: true },
      data: { required: true }
    },

    template: `
                <div class="form-control">
                  <label>{{ field.title }}</label>
                  <label class="input">
                    <input type="checkbox" v-model="data[field.name]">
                  </label>
                </div>
                `
  };

  const file = {
    props: {
      field: { required: true },
      data: { required: true },
      fileFunction: {type: Function}
    },

    template: `
         <div class="form__item">
            <label class="form__label--span form--left"><span>{{ field.title }}</span></label>
            <div class="form--right">
              <input ref="file" type="file" v-on:change="fileFunction(field.name)" required="field.required"/>
            </div>

        </div>
  `
  };

  const vForm = {

    template: `
            <div>
            <div class="" v-for="(steps,index) in new_schema" v-show="(index == step)">
            <transition name="slide-fade">
                <div class="compliance__steps compliance__steps--one">

                  <form action="" class="form compliance-form">
                        <div class="VueForm">
                    <div v-for="(field,ind) in new_schema[index]">
                      <component :is="field.type" :field="field" :data="data[index-1]" :fileFunction="submitFile" ref="file"></component>
                    </div>
                  </div>
                  <br>
                  <br>
                  <div style="float: right;">
                    <a v-if="index <= total && index > 1" class="btn btn--default Submit" id="Submit" @click="next('backStep')">PREVIOUS STEP</a>
                    <a v-if="index < total" class="btn btn--primary Submit" id="Submit" @click="next('nextStep')">NEXT STEP</a>
                    <a v-else-if="index = total" id="Submit_button" class="btn btn--primary Submit_button" @click="submit">SUBMIT</a>
                  </div>
                  </form>
                </div>
              </transition>
            </div>
            </div>
            `,

    components: {
      textInput: textInput,
      checkboxInput: checkboxInput,
      file: file
    },

    props: {
      schema: { required: true },
      count: { required: true },
      total: {required:true },
      new_schema: {required: true},
      step: {required: true},
      notDone: {required: true},
      next: { type: Function },
      submit: {type: Function},
      submitFile: { type: Function },
      data: {required: true}
    },

  };

  Vue.component('v-form', vForm);


  export default {

    beforeRouteEnter(to, from, next){
      let token = Vue.$cookies.get('token');
      if (!token) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        next({
          path: '/login',
        })

      }
      else {
        next() // make sure to always call next()!
      }
    },

    bforeCreate() {
      this.companyType = 8;

    },

    mounted () {
      //   When dashboardbase.vue is done, finish loading the progress bar
      this.$Progress.finish();
      this.idleTimer();
      this.compliance = window.localStorage.getItem('compliance');
    },

    created () {
      // this.getFilteredData('ANGUS BROWn');
      //fetch some APIs in the background on created
      this.$store.dispatch('handleBanksFetch');

      //  start progress bar when dashboardBase is created
      //  all progress bar configurations
      this.$Progress.start()
      //  hook the progress bar to start before we move router-view
      this.$router.beforeEach((to, from, next) => {
        //  does the page we want to go to have a meta.progress object
        if (to.meta.progress !== undefined) {
          let meta = to.meta.progress
          // parse meta tags
          this.$Progress.parseMeta(meta)
        }
        //  start the progress bar
        this.$Progress.start()
        //  continue to next page
        next()
      });
      //  hook the progress bar to finish after we've finished moving router-view
      this.$router.afterEach((to, from) => {
        //  finish the progress bar
        this.$Progress.finish()
      });
        this.countData();
    },

    data() {
      return {
        open: false,
        formSchema: {
          json_data: [
            {
              "title": "Business Name",
              "name": "business-name",
              "type": "text-input",
              "required": false
            },
            {
              "title": "Business Address",
              "name": "business-address",
              "type": "text-input",
              "required": true
            },
            {
              "title": "MTO License",
              "name": "mto-doc",
              "type": "file",
              "required": true
            },
            {
              "title": "CAC Documentation",
              "name": "cac-doc",
              "type": "file",
              "required": true
            },
            {
              "title": "Business Registration Number",
              "name": "business-reg-number",
              "type": "text-input",
              "required": true
            }
            ,{
              "title": "Shareholders",
              "name": "shareholders-doc",
              "type": "file",
              "required": true
            },
          ],
        },
        filteredSearch: '',
        filteredSearchEmpty: true,
        filteredData: {},
        newFilteredData: [],
        keyForFilteredData: [],
        new_json_data: {},
        new_array_data:[],
        objJsonData: {},
        objArrData: [],
        count2: 0,
        total: 0,
        per_page: 3,
        activated: '',
        file: '',
        new_file: {},
        companyType: '',
        contactName: '',
        contactPhone: '',
        country: '',
        registeredName: '',
        registeredNumber:'',
        url:'',
        step: 1,
        done: false,
        success: false,
        complianceError:[],
        failed: false,
        notDone: true,
        disabled: false,
        password: '',
        dropdownOpen:false,
        userName:'',
        userFirstName:this.$cookies.get('userFirstName') !== null ? this.$cookies.get('userFirstName') : '',
        userLastName:this.$cookies.get('userLastName') !== null ? this.$cookies.get('userLastName') : '',
        complianceHeaderInfo:{
          stepTitleOne:"Add a Card or Bank account",
          step:"1",
          steps:"2",
          stepText:"Card information",
          stepTextTwo:"Verify your information",
        },
        isBankForm:false,
        isCardForm:true,
        isStepOneComplete: false,
        isStepOneOfTwoComplete: false,
        isStepTwoOfTwoComplete: false,
        isStepOne: true,
        isStepTwo: false,
        isNigerian:true, //data from API should show if user's country is Nigeria or something to set if this is true or false
        isIndividual: true, //data from API should show if user chose company or individual during onboarding
        isCompany: false,
        compliance: this.$store.state.authUser.compliance,
        posMerchant: JSON.parse(window.localStorage.getItem('posMerchant')) || false,
      }

    },
    components:{
      'sidebar-view': SidebarView,
      // 'auto_implemented_form': auto_form
    },

    watch:{
      $route (to, from){
        this.open = false;
      }
    },
    computed:{
      userFullName() {
        if (this.userLastName !== '' && this.userLastName !== '') {
          return this.$cookies.get('userFirstName') + ' ' + this.$cookies.get('userLastName');
        }
        else{
          return this.userFirstName
        }
      },
    },

    mounted() {
      this.getUserInfo();
    },

    methods:{
        momentDate(date){
        return moment(date).format('MMM Do, YY')
      },
      getUserInfo(){
        getUser()
          .then(response => {
            if(response.status === 200){
              if(response.data.enableDashboardActions) {
                this.$store.commit('updateEnableActions', true);
              }
            }
          })
          .catch(error => {
            console.log(error);
          })
      },
      getUserDetails(url = false){
        //after login is successful, get user details.
        getUser(url)
          .then(responseUser =>{
            this.$Progress.start();
            //cache user details if getuser api call is successful
            if(responseUser.status === 200){
              console.log(responseUser);
              this.$store.commit('updateMerchantList', responseUser.data.merchants);
              this.$store.commit('updateUserFirstName', responseUser.data.name)
              this.$store.commit('updateUserPhonenumber', responseUser.data.phonenumber)
              this.$store.commit('updateUserEmail', responseUser.data.email)
              this.$store.commit('updateUserBusinessName', responseUser.data.merchants[0].name)
              this.$store.commit('updateUserAccountNumber', responseUser.data.merchants[0].account);
              this.$store.commit('updateCompliance', responseUser.data.merchants[0].compliance);
              this.$store.commit('updateUserMerchantId', responseUser.data.merchants[0].id);
              this.$store.commit('updateUserMerchantPosState', responseUser.data.merchants[0].posMerchant || false);
              let permissions = responseUser.data.merchants[0].permission || [];
              // to be removed later
              if (JSON.parse(window.localStorage.getItem('staging')) === true && permissions.length === 0) permissions = ["wallet.disburse", "wallet.list"];
              this.$store.commit('updateUserPermissions', permissions);
              this.$router.push('/overview'); location.reload();
            }
          })
        .catch(error =>{
            this.$Progress.fail()
            console.log(this.errors);
        })
      },
      changeStep(whatAmI){
        if(whatAmI === 'nextStep'){
          if (this.step < Object.keys(this.new_json_data).length){
            this.step = this.step + 1;
          }
        }
        else if(whatAmI === 'backStep'){
          if (this.step > 1){
            this.step = this.step - 1;
          }
        }
      },
      redirect() {
        this.$router.push('/compliance');
      },
      removeFilter(){
        this.newFilteredData= [];
        this.keyForFilteredData= [];
        this.filteredSearch = '';
        this.filteredSearchEmpty = true;
      },
      getFilteredData(data){
          this.$Progress.start();
          globalSearch(data).then((response)=> {
              this.filteredData = {};
              this.newFilteredData= [];
              this.keyForFilteredData= [];
              if(Object.keys(response.data.data.beneficiaryResponse).length > 0 || Object.keys(response.data.data.transactionsResponse).length > 0 || response.data.data.walletsResponse !== null){
                  if(Object.keys(response.data.data.beneficiaryResponse).length > 0){
                      Object.keys(response.data.data.beneficiaryResponse).forEach((response1) => {
                          this.newFilteredData.push(response.data.data.beneficiaryResponse[response1]);
                          this.keyForFilteredData.push('beneficiary');
                      });
                      // this.filteredData.beneficiary = response.data.data.beneficiaryResponse[0];
                  }
                  if(Object.keys(response.data.data.transactionsResponse).length > 0){
                      Object.keys(response.data.data.transactionsResponse).forEach((response1) => {
                          this.newFilteredData.push(response.data.data.transactionsResponse[response1]);
                          this.keyForFilteredData.push('transaction');
                      });
                      this.filteredData.transaction = response.data.data.transactionsResponse[0];
                  }
                  if(response.data.data.walletsResponse !== null){
                      this.newFilteredData.push( response.data.data.walletsResponse);
                      this.keyForFilteredData.push('wallet');
                      // this.filteredData.wallet = response.data.data.walletsResponse;
                  }
                  this.filteredSearchEmpty = false;
                  this.$Progress.finish();
              }
              else{
                  this.$Progress.fail();
                  this.filteredSearchEmpty = true;
              }
          }).catch((error)=>{
              console.log(error);
              this.$Progress.fail();
              this.filteredSearchEmpty = true;
          })
      },

      countData(){
        this.count2 = Object.keys(this.formSchema.json_data).length;
        let a = 1;
        for(let v= 0; v<this.count2; v++){
          this.new_array_data.push(this.formSchema.json_data[v]);
          this.objJsonData[(this.formSchema.json_data[v]['name'])] = '';
          if( (v+1) % this.per_page === 0 || (v+1) === this.count2 ){
            this.new_json_data[a] = this.new_array_data;
            this.objArrData.push(this.objJsonData);
            this.new_array_data = [];
            this.objJsonData = {};
            a = a +1;
          }
          this.total = Object.keys(this.new_json_data).length;
        }
      },
        newSubmitVerification(){
          let file = [];
          let submitBtn = document.getElementById("Submit_button");
          let button = document.getElementById("Submit");
          submitBtn.disabled = true;
          // $(".Submit_button").prop('disabled', true);
          // $("#Submit_button").prop('disabled', true);
          button.disabled = true;
          submitBtn.innerHTML = "Processing..";

          let data = {};
          let promise = [];
          let new_file_array = [];
          let new_file_json = {};
          this.$Progress.start();

          this.objArrData.forEach((element) => {
            for(let i=0; i<Object.keys(element).length; i++){
              if(Object.values(element)[i] !== ''){ data[Object.keys(element)[i]] = Object.values(element)[i]; }
            }
          });
          if(Object.keys(data).length === 0){
            this.complianceError.push('Form is empty');
          }
          file = Object.values(this.new_file);
          if(file < 1){
            this.complianceError.push('You must submit a file');
          }
          Object.keys(this.new_file).forEach((response,index) =>{
            new_file_array[index] = response;
          });
          if(this.complianceError < 1){
            // file = Object.values(this.new_file);
            file.forEach((response) => {
              promise.push(uploadFile(response, response.name))
            //   promise.push(client.upload(response));
            });
            Promise.all(promise).then((response) => {
              response.forEach((data2,index) => {
                if(data2['data']['url']){
                  new_file_json[new_file_array[index]] = data2['data']['url']
                }
              });
              Object.values(new_file_json).forEach((response, index) => {
                data[new_file_array[index]] = response
              });
              data = JSON.stringify(data);
                verifiedService(data).then((response) => {
                  this.done = true;
                  this.success = true;
                  this.failed = false;
                  this.$Progress.finish();
                  this.notDone = false;
                }).catch((error) => {
                  this.$Progress.fail();
                  console.log(error);
                  this.complianceError.push(error.message);
                  this.done = true;
                  this.success = false;
                  this.failed = true;
                  this.notDone = false;
                })
            }).catch((error) => {
              console.log(error);
              this.$Progress.fail();
              this.complianceError.push(error.message);
              this.done = true;
              this.success = false;
              this.failed = true;
              this.notDone = false;
            });
          }
          else{
            this.$Progress.fail();
            this.done = true;
            this.success = false;
            this.failed = true;
            this.notDone = false;
          }
        },

      submitVerification(){
        let compl_error = this.complianceError;
        let submitBtn = document.getElementById("submit_button");
        let fileBtn = document.getElementById("file");
        submitBtn.disabled = true;
        fileBtn.disabled = true;
        $(".submit_button").prop('disabled', true);
        submitBtn.innerHTML = "Processing...";
          let data = {};
        this.$Progress.start();
        if(this.companyType !== ""){ data.companyType = this.companyType; }
        if(this.contactName !== ""){ data.contactName = this.contactName; }
        if(this.contactPhone !== ""){ data.contactPhone = this.contactPhone; }
        if(this.country !== ""){ data.country = this.country; }
        if(this.registeredName !== ""){ data.registeredName = this.registeredName; }
        if(this.registeredNumber !== ""){ data.registeredNumber = this.registeredNumber; }
        if(this.url !== ""){ data.url = this.url; }

        if(this.complianceError < 1){
          uploadFile(this.file, this.file.name).then((response) => {
            if(response.data.url){
              data.file = response.data.url;
              data = JSON.stringify(data);
              verifiedService(data).then((response) => {
                this.done = true;
                this.success = true;
                this.failed = false;
                this.$Progress.finish();
                this.notDone = false;
              }).catch((error) => {
                this.$Progress.fail();
                console.log(error);
                this.complianceError.push(error.message);
                this.done = true;
                this.success = false;
                this.failed = true;
                this.notDone = false;
              });
            }
          })
              .catch((error) => {
                console.log(error);
                compl_error.push(error.message);
                this.$Progress.fail();
                this.done = true;
                this.success = false;
                this.failed = true;
                this.notDone = false;
              });
        }
        else{
          this.$Progress.fail();
          this.done = true;
          this.success = false;
          this.failed = true;
          this.notDone = false;
        }

        },

        handleNewFileUpload(name){
            this.$nextTick(()=> {
              Object.keys(this.$refs.file.$children).forEach((element) => {
                if(Object.keys(this.$refs.file.$children[element].$refs).length !== 0){
                  if(this.$refs.file.$children[element].field.name === name){
                    if(this.$refs.file.$children[element].$refs.file.files.length !== 0){
                      this.new_file[this.$refs.file.$children[element].field.name] = this.$refs.file.$children[element].$refs.file.files[0];
                      let myarray = ["jpeg", 'png', 'pdf', 'jpg'];
                      let arraycontain = (myarray.indexOf(this.$refs.file.$children[element].$refs.file.files[0].name.split('.').pop()) > -1);
                      if(arraycontain === false){
                        this.complianceError.push('File not accepted');
                            }
                          }
                      }
                  }
                });
            });
        },
      handleFileUpload(){
        this.file = this.$refs.file.files[0];
        let myarray = ["jpeg", 'png', 'pdf', 'jpg'];
        let arraycontain = (myarray.indexOf(this.$refs.file.files[0].name.split('.').pop()) > -1);
        // jpeg, png and pdf
        if(arraycontain === false){
          this.complianceError.push('File not accepted');
        }
      },
      endModal(){
        this.done = false;
        this.success = false;
        this.failed = false;
        this.notDone = true;
        this.isStepOne = true;
        this.isStepTwo = false;
        this.isStepOneComplete = false;
        this.complianceError = [];
        this.step = 1;
      },
      triggerPageLoad() {
        let self = this;
        // self.$router.replace(this.$route.name);
        self.beneficiarycomplianceError = [];
        self.showModal = false;
        self.addBeneficiaryNotFinished = true;
        self.addBeneficiaryFailed = false;
        self.addBeneficiarySuccessful = false;
      },
      switchToBenefi(beneId){
          this.$router.push({name:'overview'});
          this.$router.push({name:'single-transfer', params: {id: beneId}});
      },
      //start controls for compliance modal
      showBankForm(){
        this.isCardForm = false;
        this.isBankForm = true;
      },
      showCardForm(){
        this.isCardForm = true;
        this.isBankForm = false;
      },
      stepOneComplete(){
        this.isStepOne = false;
        this.isStepOneComplete = true;
        this.isStepTwo = true;
        this.step = 2;
      },
      stepOneOfTwoComplete(){
        this.isStepTwo = false;
        this.isStepOneOfTwoComplete = true;
      },

      //control the click out of the dropdown
      dropDownControl(){
        this.dropdownOpen = false
      },
      //*******compliance controls ended *********//


      //******detect inactivity*****//
      idleTimer() {
          let t;
          window.onload = resetTimer;
          window.onmousemove = resetTimer; // catches mouse movements
          window.onmousedown = resetTimer; // catches mouse movements
          window.onclick = resetTimer;     // catches mouse clicks
          window.onscroll = resetTimer;    // catches scrolling
          window.onkeypress = resetTimer;  //catches keyboard actions

        function logoutUser() {
            return logout(() =>{
              location.reload()
            })
          }

          function resetTimer() {
            clearTimeout(t);
            t = setTimeout(logoutUser, 1.2e+6);  // logoutuser after 20mins, time is in milliseconds (1000 is 1 second)
          }
       },
      ////end

      //logout
      handleLogout(){
        return logout(() =>{
          var route = '';
          if(window.localStorage.getItem('loginType') !== null){
            route = 'http://moneywave.test/logout';
          }
          window.localStorage.clear();
          if(route.length > 0){
            window.open(route, "_self");
          }
          else{
           this.$router.push('/login');
           location.reload()
          }
        })
      }

    }

  }
</script>



// WEBPACK FOOTER //
// src/components/base/DashboardBase.vue